import LineBagIcon from 'components/Luxkit/Icons/line/LineBagIcon'
import LineBagSlashIcon from 'components/Luxkit/Icons/line/LineBagSlashIcon'
import LineLuggageIcon from 'components/Luxkit/Icons/line/LineLuggageIcon'
import LineLuggageSlashIcon from 'components/Luxkit/Icons/line/LineLuggageSlashIcon'
import CaptionTextBlock from 'components/Luxkit/TextBlocks/CaptionTextBlock'
import React from 'react'

export interface Props {
  carryOnIncluded?: boolean;
  checkedBaggageIncluded?: boolean;
  showCheckedBaggage?: boolean;
}

function FareFamilyFlightTileV2Baggage(props: Props) {
  const {
    carryOnIncluded,
    checkedBaggageIncluded,
    showCheckedBaggage = true,
  } = props

  return (
    <>
      <CaptionTextBlock
        variant="medium"
        startIcon={
          carryOnIncluded ? (
            <LineBagIcon colour="highlight-secondary" />
          ) : (
            <LineBagSlashIcon />
          )
        }
      >
        {carryOnIncluded && 'Carry-on'}
        {!carryOnIncluded && 'No carry-on'}
      </CaptionTextBlock>

      {showCheckedBaggage && <CaptionTextBlock
        variant="medium"
        startIcon={
          checkedBaggageIncluded ? (
            <LineLuggageIcon colour="highlight-secondary" />
          ) : (
            <LineLuggageSlashIcon />
          )
        }
      >
        {checkedBaggageIncluded && 'Checked bag'}
        {!checkedBaggageIncluded && 'No checked bag'}
      </CaptionTextBlock>}
    </>
  )
}

export default FareFamilyFlightTileV2Baggage
